module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "display-3 grey--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('page_not_found')))]), _vm._v(" "), _c('div', {
    staticClass: "body-2 my-3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'welcome'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('go_home')) + "\n          ")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1ff9aa2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/errors/404.vue
// module id = CSll
// module chunks = 1